module.exports = __webpack_public_path__ + "js/stellarium-web-engine.3fed33b5.wasm";